<template>
    <div class="person">
        <div class="condition">
            <queryCondition ref="query" :list="queryList" :value="conditionData" labelWidth="120px" :search="selectData" :reset="reset"></queryCondition>
        </div>
        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="nickName" label="代理团长" align="center"></el-table-column>
                <!-- <el-table-column prop="agentName" label="代理名称" align="center"></el-table-column> -->
                <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
                <el-table-column prop="yRegisterNum" label="邀请注册人数" align="center"></el-table-column>
                <el-table-column prop="rechargeTotalSum" label="累计充值金额" align="center"></el-table-column>
                <el-table-column prop="yongJinRatio" label="分佣比例" align="center">
                    <template slot-scope="scope">
                        {{scope.row.yongJinRatio*100}}%
                    </template>
                </el-table-column>
                <el-table-column prop="rebateTotalSum" label="累计奖励金额" align="center"></el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="250px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="InviteDetail(scope.row)">查看邀请明细</el-button>
                    <el-button type="text" icon="el-icon-zoom-in" size="mini" @click="personDetail(scope.row)">查看团员</el-button>
                </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    background
                    layout="sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    :page-sizes="[10, 20, 50, 100]"
                    :current-page="conditionData.page"
                    :page-size="conditionData.pageSize">
                </el-pagination>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="isAddDialog" title="新增" width="500px">
            <forms ref="formListAdd" :list="formList" :value="formData" :rules="formRules" :btns="formAddBtns" labelWidth="120px"></forms>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isUpdateDialog" title="编辑" width="500px">
            <forms ref="formListEdit" :list="formList" :value="formData" :rules="formRules" :btns="formEditBtns" labelWidth="120px"></forms>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isInviteListDialog" title="邀请明细" width="1500px">
            <el-table
                :data="inviteList"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%"
                height="500px">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="nickName" label="邀请人用户昵称" align="center" width="150"></el-table-column>
                <el-table-column prop="phone" label="邀请人手机号码" align="center" width="140">
                    <template slot-scope="scope">
                        {{scope.row.phone}}
                    </template>
                </el-table-column>
                <el-table-column prop="rechargeNickName" label="被邀请人用户昵称" align="center" width="150"></el-table-column>
                <el-table-column prop="rechargePhone" label="被邀请手机号码" align="center" width="140"></el-table-column>
                <el-table-column prop="creationTime" label="充值时间" align="center" width="160"></el-table-column>
                <el-table-column prop="rechargeTotal" label="充值金额" align="center"></el-table-column>
                <el-table-column prop="yongJinRatio" label="分佣比例" align="center">
                    <template slot-scope="scope">
                        {{scope.row.yongJinRatio*100}}%
                    </template>
                </el-table-column>
                <el-table-column prop="rebateTotal" label="奖励金额" align="center"></el-table-column>
                <el-table-column prop="payType" label="支付类型" align="center">
                    <template slot-scope="scope">
                        {{scope.row.payType == 1?'会员':''}}
                        {{scope.row.payType == 2?'充值金币':''}}
                    </template>
                </el-table-column>
                <el-table-column prop="payState" label="支付结果" align="center">
                    <template slot-scope="scope">
                        {{scope.row.payState == -1?'退款':''}}
                        {{scope.row.payState == 0?'未支付':''}}
                        {{scope.row.payState == 1?'支付完成':''}}
                    </template>
                </el-table-column>
                <el-table-column prop="payFrom" label="支付方式" align="center">
                    <template slot-scope="scope">
                        {{scope.row.payFrom == 1?'微信支付':''}}
                        {{scope.row.payFrom == 2?'支付宝支付':''}}
                        {{scope.row.payFrom == 3?'苹果支付':''}}
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" :visible.sync="isPersonListDialog" title="团员列表" width="1000px">
            <el-table
                :data="personList"
                border
                :header-cell-style="tableHeaderColor"
                style="width: 100%"
                height="500px">
                <el-table-column type="index" width="60" label="序号" align="center"></el-table-column>
                <el-table-column prop="nickName" label="昵称" align="center"></el-table-column>
                <el-table-column prop="phone" label="手机号码" align="center"></el-table-column>
                <el-table-column prop="yRegisterNum" label="邀请注册人数" align="center"></el-table-column>
                <el-table-column prop="rechargeTotalSum" label="累计充值金额" align="center"></el-table-column>
                <el-table-column prop="yongJinRatio" label="分佣比例" align="center">
                    <template slot-scope="scope">
                        {{scope.row.yongJinRatio*100}}%
                    </template>
                </el-table-column>
                <el-table-column prop="rebateTotalSum" label="累计奖励金额" align="center"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import queryCondition from '../../../components/queryCondition'
import forms from '../../../components/form'
import {wtlxList,isNewList} from '../../../assets/selectList/index'
import {parseTimeS} from '../../../utils/index'
export default {
    name: 'person',
    components:{
        queryCondition,
        forms
    },
    watch: {
    },
    data () {
        return {
            isAddDialog:false,
            isUpdateDialog:false,

            totalCount:0,
            tableData:[],

            conditionData:{
                Phone:'',
                page:1,
                pageSize:10,
            },
            queryList:[
                {type: "input",label: "手机:",name: "Phone",},
            ],
           cashStateList: [{
                label:'已提交',
                value:1,
            },{
                label:'提现完成',
                value:2,
            },{
                label:'提现失败',
                value:-1,
            }],
            formData:{
                Name:'',
                Type:'',
                UnderwritingAgency:'',
                IsNew:'',
            },
            formList:[
                {type: "input",label: "委托主体名称:",name: "Name",},
                {type: "select",label: "委托主体类型:",name: "Type",options:wtlxList},
                {type: "input",label: "承保机构:",name: "UnderwritingAgency",},
                {type: "select",label: "是否新来源:",name: "IsNew",options:isNewList},
            ],
            // 提交规则
            formRules:{
                Name: [{ required: true, message: '请填写委托主体名称', trigger: 'blur' }],
                Type: [{ required: true, message: '请填写委托主体类型', trigger: 'change' }],
                UnderwritingAgency: [{ required: true, message: '请填写承保机构', trigger: 'blur' }],
                IsNew: [{ required: true, message: '请填写是否新来源', trigger: 'change' }],
            },
            formAddBtns:[
                {name:'确认新增',icon:'el-icon-circle-plus',type:'success',handleClick:this.add},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],
            formEditBtns:[
                {name:'确认编辑',icon:'el-icon-edit',type:'success',handleClick:this.edit},
                {name:'关闭',icon:'el-icon-error',type:'warning',handleClick:this.close}
            ],

            isEditDialog:false,
            editData:{
                
            },
            inviteList:[],
            isInviteListDialog:false,

            personList:[],
            isPersonListDialog:false,

        }
    },
    created(){
    },
    mounted(){
        setTimeout(() => {
            this.loadingData();
        }, 300)
    },
    methods:{
        async InviteDetail(row){
            let res  = await api.AdminAgentQueryAgentRecordByUserId({userId:row.userId});
            this.isInviteListDialog = true;
            this.inviteList = res.data.data.data;
        },
        async personDetail(row){
            let res  = await api.AdminAgentQueryAgentByUserId({userId:row.userId});
            this.isPersonListDialog = true;
            this.personList = res.data.data.data;
        },
        // table表头样式
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        // 加载table数据
        async loadingData() {
            
            let res  = await api.AdminAgentQueryAgents(this.conditionData);
            console.log(res.data.data)
            this.tableData = res.data.data.data;
            this.totalCount = res.data.data.totalCount;
        },
        // 查询
        selectData(){
            this.conditionData.page = 1;
            this.loadingData();
        },
        // 重置查询
        reset(){
            this.conditionData = {
                Phone:'',
                page:1,
                pageSize:10,
            },
            this.loadingData();
        },
        // 切换页面
        handleCurrentChange(page){
            this.conditionData.page = page;
            this.loadingData();
        },
        // 切换页面条数
        handleSizeChange(pageSize){
            this.conditionData.page = 1;
            this.conditionData.pageSize = pageSize;
            this.loadingData();
        },
        // 新增弹窗
        showAddDialog(e){
            this.isAddDialog = true;
        },
        // 新增方法
        async add(){
            let flag = this.$refs["formListAdd"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.InsuranceCompanyAdd(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '添加成功',
                    type: 'success'
                });
                this.$refs["formListAdd"].resetFields();
                this.loadingData();
            }
        },
        isUpdateDialogShow(row){
            console.log(row);
            this.isUpdateDialog = true;
            this.formData = {
                id:row.id,
                Name:row.name,
                Type:row.type,
                UnderwritingAgency:row.underwritingAgency,
                IsNew:row.isNew,
            }
        },
        // 编辑方法
        async edit(){
            let flag = this.$refs["formListEdit"].validateForm();
            if(!flag){
                return;
            }
            let res  = await api.InsuranceCompanyEdit(this.formData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.$refs["formListEdit"].resetFields();
                this.isUpdateDialog = false;
                this.loadingData();
            }
        },
        // 关闭新增和编辑的弹框
        close(){
            if(this.isAddDialog){
                this.isAddDialog = false
            }else if(this.isUpdateDialog){
                this.isUpdateDialog = false
                this.$refs["formListEdit"].resetFields();
            }
        },
        // 删除提示
        deleteRowTip(row){
            this.$confirm('将删除委托主体——'+row.name+', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRow(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消退出'
                });          
            });
        },
        // 删除方法
        async deleteRow(row){
            let res  = await api.InsuranceCompanyDel({id:row.id});
            if(res.data.code == '200') {
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        async editDataFun(){
            let res  = await api.AdminCashUpdateCashState(this.editData);
            if(res.data.code == '200') {
                this.$message({
                    message: '编辑成功',
                    type: 'success'
                });
                this.isEditDialog = false
                this.loadingData();
            }
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        border-radius: 5px;
        padding: 15px;
        font-size: 14px;
        
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        .item{
            display: flex;
            align-items: center;
            .label{
                width: 120px;
            }
        }
    }
</style>
